'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = utms;

var _immutable = require('immutable');

var _TrialInfoActionTypes = require('../actionTypes/TrialInfoActionTypes');

var DEFAULT = (0, _immutable.Map)({
  trialType: '',
  trialDuration: 30
});

function utms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _TrialInfoActionTypes.STORE_TRIAL_INFO:
      {
        return state.merge(payload);
      }
    default:
      {
        return state;
      }
  }
}
module.exports = exports['default'];